import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import TextField from 'material-ui/TextField';

const mapDispatchToProps = dispatch => ({
  onMediumClick: payload => dispatch({type: 'MEDIUM_CLICK', payload}),
  onSearchChange: payload => dispatch({type: 'SEARCH_CHANGE', payload})
});

const mapStateToProps = state => ({
  ...state.mediums,
  ...state.artists
});

const styles = {
  li: {
    listStyle: "none",
    marginBottom: "2px",
    letterSpacing: ".5px"
  },
  link: {

  },
  linkActive: {
    color: '#000'
  },
  ul: {
    padding: '0'
  },
  search: {
    width: '95%',
    color: '#666',
    borderColor: "#666",
    fontFamily: '"Chivo", sans-serif',
    fontWeight: '300',
    borderWidth: '1px'
  },
  input: {
    width: '95%',
    color: '#000',
    fontFamily: '"Chivo", sans-serif',
    fontWeight: '300',
  },
  searchUnderline: {
    width: "95%"
  }
}

class Sidebar extends React.Component {

  onMediumClick(e, medium) {
    e.preventDefault();
    window.scrollTo(0, 0);

    this.props.onMediumClick(medium);
  }

  handleUpdateInput(e, value) {
    this.props.onSearchChange(value);
  }

  render() {

    const mediums = Object.keys(this.props.mediums).map(medium => {
      if(this.props.medium && this.props.medium == medium)
      {
        return (
          <li style={styles.li} key={medium}>
            <Link className="Medium" key={medium} style={styles.linkActive} to="" onClick={e => this.onMediumClick(e, medium)}>
              {this.props.mediums[medium]}
            </Link>
          </li>
        )
      } else {
        return (
          <li style={styles.li} key={medium}>
            <Link className="Medium" key={medium} to="" onClick={e => this.onMediumClick(e, medium)}>
              {this.props.mediums[medium]}
            </Link>
          </li>
        )
      }

    });

    const dataSource = [];
    let searchStr = this.props.search ? this.props.search : "";

    return (
      <div>
        <div>
        <TextField
          hintText="Search"
          hintStyle={{color:"#666"}}
          underlineFocusStyle={styles.search}
          inputStyle={styles.input}
          style={styles.search}
          defaultValue={searchStr}
          underlineStyle={styles.searchUnderline}
          onChange={this.handleUpdateInput.bind(this)}
        />
        </div>
        <ul style={styles.ul}>
          <li style={styles.li}>
            <Link className="Medium" style={styles.link} to="" onClick={e => this.onMediumClick(e, null)}>All</Link>
          </li>
          {mediums}
        </ul>
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Sidebar);



// WEBPACK FOOTER //
// ./src/components/Sidebar.js